<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>

      <Sidebar></Sidebar>

      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">List of company</h4>
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12">
              <div class="white-box">
                <div class="uper-add-row">
                  <h3 class="box-title"></h3>
                  <el-button
                    size="mini"
                    type="success"
                    @click="$router.push({ path: '/partner/create' })"
                    >+ Add</el-button
                  >
                </div>
                <div class="table-responsive users_table">
                  <el-table
                    :data="
                      employeesData.filter(
                        (data) =>
                          !search ||
                          data.name.toLowerCase().includes(search.toLowerCase())
                      )
                    "
                    style="width: 100%"
                  >
                    <el-table-column label="Sr No." prop="index">
                    </el-table-column>

                    <el-table-column label="First Name" prop="firstname">
                    </el-table-column>
                    <el-table-column label="Last Name" prop="lastname">
                    </el-table-column>

                    <el-table-column label="Created" prop="created">
                    </el-table-column>

                    <el-table-column min-width="55" prop="image" label="Image">
                      <template slot-scope="scope">
                        <img
                          v-if="scope.row.image"
                          :src="scope.row.image"
                          alt="user image"
                        />
                        <img
                          v-else
                          src="./../../assets/front/image/profile_img2.jpg"
                          alt="user image"
                        />
                      </template>
                    </el-table-column>

                    <el-table-column align="right">
                      <template slot-scope="scope">
                        <!--<el-button
                          size="mini"
                          type="info"
                          @click="
                            $router.push({
                              path: '/partner/edit/' + scope.row.id,
                            })
                          "
                          >Edit</el-button>-->

                        <el-button
                          size="mini"
                          type="info"
                          @click="
                            $router.push({
                              path: '/partner/edit/' + scope.row.id,
                            })
                          "
                          >Edit</el-button
                        >

                        <el-button
                          size="mini"
                          type="danger"
                          @click="deleteEmployee(scope.row.id)"
                          >Delete</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  </body>
</template>

<script>
import Header from "./../admin-header";
import Footer from "./../admin-footer";
import Sidebar from "./../admin-sidebar";
import firebase from 'firebase';
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { db } from "../../main";

Vue.use(VueAxios, axios);

export default {
  components: {
    Header: Header,
    Sidebar: Sidebar,
    Footer: Footer,
  },
  data() {
    return {
      name: "",
      about: "",
      date: new Date().toISOString().slice(0, 10),
      employeesData: [],
      search: "",
    };
  },
  methods: {
    readEmployees() {
      this.employeesData = [];
      var i = 1;
      db.collection("partner")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.employeesData.push({

              index: i,
              firstname: doc.data().title,
              lastname: doc.data().address,id: doc.id,
              image: doc.data().companylogo,
              created: doc.data().created,
              modified: doc.data().modified,
            });
            console.log(doc.id, " => ", doc.data());
            i++;
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
		//

		//
    },
    deleteEmployee(id) {
      if (confirm("Do you really want to delete?")) {

	  //
        let storage = [];
	db.collection('partner').doc(id)
			.get().then(snapshot => {
				if (!snapshot.exists) return;
                var companylogos = snapshot.data().companylogo;
				  companylogos = companylogos.split("?")[0];
				  companylogos = companylogos.split("o/")[1];
                   storage.push(companylogos);

				//
				var companyheroimaged = snapshot.data().companyheroimage;
				  companyheroimaged = companyheroimaged.split("?")[0];
				  companyheroimaged = companyheroimaged.split("o/")[1];
				  storage.push(companyheroimaged);

				//
				var  secondsectionimages = snapshot.data().secondsectionimage;
				 secondsectionimages = secondsectionimages.split("?")[0];
				  secondsectionimages = secondsectionimages.split("o/")[1];
				  console.log(secondsectionimages);
                 storage.push(secondsectionimages);
				//
				 var thirdsectionimage = snapshot.data().thirdsectionimage;
                 thirdsectionimage = snapshot.data().secondsectionimage;
				 thirdsectionimage = thirdsectionimage.split("?")[0];
				  thirdsectionimage = thirdsectionimage.split("o/")[1];
				 storage.push(thirdsectionimage);
			});
		  setTimeout(() => {
			storage.map(function(value) {
				 firebase.storage().ref().child(value).delete();
		   });
		  }, 1000);
	  //
        db.collection("partner")
          .doc(id)
          .delete()
          .then(() => {
            console.log("Document successfully deleted!");
            this.readEmployees();
            this.$toasted.success("Success, Deleted Successfully!", {
              icon: "check",
              //icon : 'error_outline'
            });
            //this.$router.push('/users/index');
          })
          .catch((error) => {
            console.error("Error removing document: ", error);
          });
      }
    },
  },
  mounted() {
    this.readEmployees();
  },
};
</script>
